<template>
  <div class="busy-spinner-big">
    <div class="spinner-icon-container row justify-space-between">
      <div class="spinner-dot mr-2"></div>
      <div class="spinner-dot mb-2"></div>
      <div class="spinner-dot mr-2"></div>
      <div class="spinner-dot"></div>
    </div>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'

  export default defineComponent({
    name: 'BusySpinner',
  })
</script>

<style scoped lang="scss">
  .busy-spinner-big {
    min-height: 120px;
    display: flex;
    .spinner-icon-container {
      width: 40px;
      height: 45px;
      margin: auto;
      animation: bysy-spinner 3.5s infinite linear;
      .spinner-dot {
        width: 15px;
        height: 15px;
        background-color: var(--orange);
        border-radius: 50%;
      }
    }
  }
  @keyframes bysy-spinner {
    0% {
      transform: rotateZ(0deg) translate3d(0, 0, 0);
    }
    100% {
      transform: rotateZ(720deg) translate3d(0, 0, 0);
    }
  }
</style>
